// skillConstants.js — Diccionario de mapeo semántico de variables de skill_effects
// Fuente: Valores.txt (src/_dev_docs/md/skill_effects/Valores.txt)
// Regla: Las variables no listadas aquí se muestran con solo su valor numérico crudo.
// Para agregar nuevas variables en el futuro: simplemente añadir una entrada al objeto SKILL_VARIABLE_LABELS.

export const SKILL_VARIABLE_LABELS = {
    corner: {
        0: 'not a corner',
        1: 'first corner',
        2: 'second corner',
        3: 'third corner',
        4: 'fourth corner',
    },
    corner_random: {
        1: 'first corner',
        2: 'second corner',
        3: 'third corner',
        4: 'fourth corner',
    },
    distance_type: {
        1: 'Sprint',
        2: 'Mile',
        3: 'Medium',
        4: 'Long',
    },
    grade: {
        100: 'G1',
        200: 'G2',
        300: 'G3',
        400: 'OP',
        700: 'Pre-OP',
        800: 'Maiden',
        900: 'Debut',
        999: 'Daily',
    },
    ground_condition: {
        1: 'Good',
        2: 'Slightly Heavy',
        3: 'Heavy',
        4: 'Bad',
    },
    ground_type: {
        1: 'Turf',
        2: 'Dirt',
    },
    is_basis_distance: {
        0: 'non-core',
        1: 'core',
    },
    is_dirtgrade: {
        0: 'False',
        1: 'True',
    },
    is_move_lane: {
        1: 'moved closer to the fence',
        2: 'moved further from the fence',
    },
    lastspurt: {
        0: 'not enough stamina',
        1: 'above base speed',
        2: 'max speed',
    },
    motivation: {
        1: 'Terrible',
        2: 'Bad',
        3: 'Normal',
        4: 'Good',
        5: 'Perfect',
    },
    phase: {
        0: 'Early-Race',
        1: 'Mid-Race',
        2: 'Late-Race',
        3: 'Last Spurt',
    },
    phase_corner_random: {
        0: 'Early-Race',
        1: 'Mid-Race',
        2: 'Late-Race',
        3: 'Last Spurt',
    },
    phase_firstquarter_random: {
        0: 'Early-Race',
        1: 'Mid-Race',
        2: 'Late-Race',
        3: 'Last Spurt',
    },
    phase_laterhalf_random: {
        0: 'Early-Race',
        1: 'Mid-Race',
        2: 'Late-Race',
        3: 'Last Spurt',
    },
    phase_random: {
        0: 'Early-Race',
        1: 'Mid-Race',
        2: 'Late-Race',
        3: 'Last Spurt',
    },
    rotation: {
        1: 'clockwise/right',
        2: 'counterclockwise/left',
    },
    running_style: {
        1: 'Front Runner',
        2: 'Pace Chaser',
        3: 'Late Surger',
        4: 'End Closer',
    },
    season: {
        1: 'spring',
        2: 'summer',
        3: 'fall',
        4: 'winter',
        5: 'cherry blossom',
    },
    slope: {
        0: 'no slope',
        1: 'up',
        2: 'down',
    },
    straight_front_type: {
        1: 'straight in front of the audience',
        2: 'straight on the opposite side',
    },
    time: {
        0: 'Any',
        1: 'Morning',
        2: 'Daytime',
        3: 'Evening',
        4: 'Night',
    },
    track_id: {
        10001: 'Sapporo',
        10002: 'Hakodate',
        10003: 'Niigata',
        10004: 'Fukushima',
        10005: 'Nakayama',
        10006: 'Tokyo',
        10007: 'Chukyo',
        10008: 'Kyoto',
        10009: 'Hanshin',
        10010: 'Kokura',
        10101: 'Ooi',
        10103: 'Kawasaki',
        10104: 'Funabashi',
        10105: 'Morioka',
    },
    weather: {
        1: 'sunny',
        2: 'cloudy',
        3: 'rainy',
        4: 'snowy',
    },
};

/**
 * Dado el nombre de una variable y su valor numérico,
 * devuelve el label semántico legible, o null si no existe mapeo.
 * Si el valor no tiene mapeo en la variable, también devuelve null.
 */
export function getVariableLabel(variable, value) {
    const map = SKILL_VARIABLE_LABELS[variable];
    if (!map) return null;
    const label = map[Number(value)];
    return label !== undefined ? label : null;
}
